import { render, staticRenderFns } from "./detallePlan.vue?vue&type=template&id=27fcd2fc&scoped=true"
import script from "./detallePlan.vue?vue&type=script&lang=js"
export * from "./detallePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcd2fc",
  null
  
)

export default component.exports